import m from "../../../../geodata/es2015/region/usa/nyHigh";
window.am4geodata_region_usa_nyHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/nyHigh.js
// module id = null
// module chunks = 